/** account_users.role values, as kim-ai-backend's RoleId and the Kim AI app name them. */
export const ROLES = [
  { value: '0', label: 'Agent' },
  { value: '1', label: 'Administrator' },
  { value: '2', label: 'AI' },
  { value: '3', label: 'Light Agent' },
  { value: '4', label: 'Client Restricted User' },
  { value: '5', label: 'Sentinel' },
  { value: '6', label: 'Read-only Admin' }
] as const;

export type RoleValue = (typeof ROLES)[number]['value'];

export const roleLabel = (role: number | string | null) =>
  ROLES.find((r) => r.value === String(role ?? 0))?.label ?? 'Agent';
